var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_release") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UX-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-154.000000, -484.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_release",
    transform: "translate(154.000000, 484.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,8.535 C13.914,8.535 15.465,10.086 15.465,12 C15.465,13.913 13.914,15.465 12,15.465 C10.086,15.465 8.535,13.913 8.535,12 C8.535,10.086 10.086,8.535 12,8.535 L12,8.535 Z M19.59,17.94 L16.4,14.778 C15.987,15.437 15.41,15.988 14.75,16.428 L17.913,19.59 L16.29,21.212 L23,23 L21.212,16.317 L19.59,17.94 Z M4.41,6.06 L7.6,9.222 C8.013,8.562 8.59,8.013 9.25,7.573 L6.06,4.41 L7.683,2.787 L1,1 L2.788,7.682 L4.41,6.06 Z M7.6,14.778 L4.41,17.94 L2.788,16.317 L1,23 L7.683,21.212 L6.06,19.59 L9.223,16.4 C8.562,15.988 8.013,15.437 7.6,14.778 L7.6,14.778 Z M16.4,9.222 L19.562,6.06 L21.185,7.682 L23,1 L16.317,2.787 L17.94,4.41 L14.777,7.6 C15.438,8.013 15.987,8.562 16.4,9.222 L16.4,9.222 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRelease);
export default __webpack_public_path__ + "static/media/ic_release.e5704f3693a6861056b8c69ade102394.svg";
export { ForwardRef as ReactComponent };